/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `CREATED` - Created
 * * `NEW` - New
 * * `WORK_IN_PROGRESS` - Work In Progress
 * * `WAITING_APPROVAL` - Waiting Approval
 * * `COMPLETED` - Completed
 * * `ARCHIVED` - Archived
 * * `REJECTED` - Rejected
 * * `LINKED` - Linked
 * @export
 */
export const EventStatusEnum = {
    Created: 'CREATED',
    New: 'NEW',
    WorkInProgress: 'WORK_IN_PROGRESS',
    WaitingApproval: 'WAITING_APPROVAL',
    Completed: 'COMPLETED',
    Archived: 'ARCHIVED',
    Rejected: 'REJECTED',
    Linked: 'LINKED'
} as const;
export type EventStatusEnum = typeof EventStatusEnum[keyof typeof EventStatusEnum];


export function instanceOfEventStatusEnum(value: any): boolean {
    for (const key in EventStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(EventStatusEnum, key)) {
            if (EventStatusEnum[key as keyof typeof EventStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EventStatusEnumFromJSON(json: any): EventStatusEnum {
    return EventStatusEnumFromJSONTyped(json, false);
}

export function EventStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventStatusEnum {
    return json as EventStatusEnum;
}

export function EventStatusEnumToJSON(value?: EventStatusEnum | null): any {
    return value as any;
}

export function EventStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): EventStatusEnum {
    return value as EventStatusEnum;
}

